﻿export interface ILogService {
    error(message: string, data?: any): void;
    warning(message: string, data?: any): void;
    info(message: string, data?: any): void;
    debug(message: string, data?: any): void;
}

export class LogService implements ILogService {
    private angularLogger: angular.ILogService;

    public static $inject = ["$log"];
    constructor($log: angular.ILogService) {
        this.angularLogger = $log;
    }

    public error(message: string, data?: any): void {
        this.angularLogger.error(message, data);
    }

    public info(message: string, data?: any): void {
        this.angularLogger.info(message, data);
    }

    public warning(message: string, data?: any): void {
        this.angularLogger.warn(message, data);
    }

    public debug(message: string, data?: any): void {
        this.angularLogger.debug(message, data);
    }
}


